// Web estática: el contenido vive en src/data/*.json y las imágenes en public/media/.
// Para editar textos o casos, modifica esos archivos.
import CONTENT from "@/data/content.json";
import PROJECTS from "@/data/projects.json";

export const resolveImg = (url) => url || "";

// Content
export const getContent = () => Promise.resolve(CONTENT);

// Projects
export const getProjects = () => Promise.resolve(PROJECTS);
export const getProject = (id) => {
  const p = PROJECTS.find((x) => x.id === id);
  return p ? Promise.resolve(p) : Promise.reject(new Error("Proyecto no encontrado"));
};

export const formatApiError = (detail) => {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
